import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import DashboardLayout from '../components/DashboardLayout';
import TabContent from '../components/TabContent';
import NotificationList from '../components/NotificationList';
import SettingsTabContent from '../components/SettingsTabContent';
import OverviewTabContent from '../components/OverviewTabContent';
import './Dashboard.module.css';

export default function Dashboard() {
  const [showNotificationList, setShowNotificationList] = useState(false);
  const [currentTab, setCurrentTab] = useState(null);
  const isAuthenticated = useSelector(state => state.auth.isAuthenticated);

  const handleShowNotifications = () => {
    setShowNotificationList(true);
  };

  const handleBackFromNotifications = () => {
    setShowNotificationList(false);
  };

  // Show loading while authentication state is being determined
  if (!isAuthenticated) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#f5f5f5'
      }}>
        <div>Loading...</div>
      </div>
    );
  }

  return (
    <DashboardLayout onShowNotifications={handleShowNotifications}>
      {(selectedTab) => {
        // Close notification list when tab changes
        if (currentTab !== selectedTab && currentTab !== null && showNotificationList) {
          setShowNotificationList(false);
        }
        setCurrentTab(selectedTab);

        return (
          <div className="dashboard-page">
            {showNotificationList ? (
              <NotificationList onBack={handleBackFromNotifications} />
            ) : selectedTab === 'overview' ? (
              <OverviewTabContent />
            ) : selectedTab === 'settings' ? (
              <SettingsTabContent />
            ) : (
              <TabContent selectedTab={selectedTab} />
            )}
          </div>
        );
      }}
    </DashboardLayout>
  );
} 